import { action } from 'satcheljs';
import type { TimeScaleSetting, TimeScaleSource } from 'owa-calendar-timescale';
import type { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';

export interface UpdateTimeScaleSettingActionMessage {
    newValue: TimeScaleSetting;
    source: TimeScaleSource;
    dateRangeType: DateRangeType | undefined;
}
export const updateTimeScaleSetting: (
    newValue: TimeScaleSetting,
    source: TimeScaleSource,
    dateRangeType?: DateRangeType
) => UpdateTimeScaleSettingActionMessage = action(
    'updateTimeScaleSetting',
    (
        newValue: TimeScaleSetting,
        source: TimeScaleSource,
        dateRangeType?: DateRangeType
    ): UpdateTimeScaleSettingActionMessage => ({
        newValue,
        source,
        dateRangeType,
    })
);
